import { SectionDataById } from './types';

type HydrateSectionData = {
  sectionsById: SectionDataById;
};

export const hydrateSectionData = ({ sectionsById }: HydrateSectionData) => {
  Object.keys(sectionsById).forEach((key) => {
    sectionsById[key].sectionId = parseFloat(key);
  });
};
